export default class ChangeValuePopup {
  id;
  min;
  max;
  confirmCallback;
  increaseCallback;
  decreaseCallback;
  inputChangeCallback;
  value;
  position;

  constructor(id, min, max, confirmCallback, increaseCallback, decreaseCallback, inputChangeCallback, value, position) {
    this.id = id;
    this.min = min;
    this.max = max;
    this.confirmCallback = confirmCallback;
    this.increaseCallback = increaseCallback;
    this.decreaseCallback = decreaseCallback;
    this.inputChangeCallback = inputChangeCallback;
    this.value = value;
    this.position = position;
  }
}
